import Vue from 'vue'
import Vuex from 'vuex'
import { format } from 'date-fns'
import parseISO from 'date-fns/esm/parseISO/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state() {
    return {
      is_initiated: false,
      initiated_pending: false,
      initiate_attempts: 0,
      pending_update: false,
      has_tokenized_pmt: false,
      stateOptions: [],
      countyOptions: [],
      termsAndConditions: [],
      inputDetails: {},
      matched_unit: {},
      oma_prefix: null,
      oma_first_name: null,
      oma_middle_name: null,
      oma_last_name: null,
      oma_suffix: null,
      oma_street_address1: null,
      oma_street_address2: null,
      oma_city: null,
      oma_state: null,
      oma_zip: null,
      oma_county: null,
      oma_primary_phone: null,
      oma_pri_phone_type: null,
      oma_secondary_phone: null,
      oma_sec_phone_type: null,
      oma_home_email: null,
      oma_preferred_name: null,
      oma_pre_memb:null,
      oma_pic_num:null,
      oma_previous_last_name: null,
      oma_dob:null,
      oma_gender: null,
      oma_ethnicity: null,
      oma_pronouns: null,
      oma_veteran_flag: null,
      oma_work_email: null,
      oma_hiredate: null,
      oma_work_phone: null,
      oma_work_phone_ext:null,
      oma_barg_unit_id: null,
      oma_job_classification:null,
      oma_school_building_id:null,
      oma_school_district_id:null,
      oma_multiple_school_districts_ind:null,
      oma_pmt_type_id: null,
      oma_mea_pac_option: null,
      oma_nea_fund: null,
      oma_mea_pac:null,
      oma_mear_opt_out_ind:null,
      cst_pac_mea: null,
      cst_pac_nea: null,
      oma_mea_pac_contribution_ind:null,
      oma_cc_bill_addr_alt_ind: 0,
      oma_cc_cardholder_name: null,
      oma_cc_num: null,
      oma_cc_expiration: null,
      oma_cc_exp_month: null,
      oma_cc_exp_year: null,
      oma_pmt_cc_sec_num:null,
      oma_pmt_cc_card_type_name:null,
      oma_cc_bill_addr_alt_zip:null,
      oma_cc_bill_addr_alt_street_line2:null,
      oma_cc_bill_addr_alt_street_line1:null,
      oma_cc_bill_addr_alt_state_code:null,
      oma_cc_bill_addr_alt_city:null,
      oma_pmt_eft_act_type:null,
      oma_pmt_eft_act_num:null,
      oma_pmt_eft_route_num:null,
      oma_pmt_eft_act_holder_name: null,
      oma_pmt_eft_bank_name: null,
      oma_pmt_token: null,
      oma_pmt_token_response: null,
      oma_additional_comment: null,
      oma_application_helpers: null,
      oma_barg_unit_detail:{
        fy_used:null,
        has_payroll_deduct:null,
        is_ibl:null,
        unit_common_name:null,
        unit_cst_msg:null,
        unit_name:null,
        org_ippd_authorization_type_ext: null,
        org_ippd_authorization_path_ext: null
      },
      
    }
  },
  getters: {
    getPacTerms(state){
      return state.termsAndConditions.filter(tnc => tnc.map_tc_name == 'map_pac_terms')[0] ?? {};
    },    
    getMainTerms(state){
      return state.termsAndConditions.filter(tnc => tnc.map_tc_name == `map_main_terms_${state.oma_barg_unit_detail.is_ibl=='1' || state.oma_barg_unit_detail.is_ipdd=='1'?'ibl':'lbl'}`)[0] ?? {};
    },
    getSignatureRegex(state){
      //build regex and add name information to the store for the signature verificaton later      
      return new RegExp(`^${state.oma_prefix?`(?:${state.oma_prefix.trim()})?[ ]*`:''}(?:${state.oma_first_name ? state.oma_first_name.trim():''})[ ]*${state.oma_middle_name?`(?:${state.oma_middle_name.trim()})?[ ]*`:''}(?:${state.oma_last_name?state.oma_last_name.trim():''})[ ]*${state.oma_suffix?`(?:${state.oma_suffix.trim()})?`:''}$`, 'i');
      //^(?:PREFIX_HERE)?[ ]*(?:FIRST_NAME_HERE)[ ]*(?:MI_HERE)?[ ]*(?:LAST_NAME_HERE)[ ]*(?:SUFFIX_HERE)?$
    },
    getUnitMsg(state){
      return state.oma_barg_unit_detail && state.oma_barg_unit_detail.unit_cst_msg ? new DOMParser().parseFromString(state.oma_barg_unit_detail.unit_cst_msg, "text/html").documentElement.textContent:false;
    },
    getCountyOptions(state){
      if(state.oma_state == null){return [];}
      return state.countyOptions.filter(v => state.oma_state == v.state_id);
    },
    getEFTActLast4(state){
      if(state.oma_pmt_eft_act_num == null){return null;}
      const numLen = state.oma_pmt_eft_act_num.length;
      return state.oma_pmt_eft_act_num.slice(numLen - 4);
    },
    getCCLast4(state){
      if(state.oma_cc_num == null){return null;}
      const numLen = state.oma_cc_num.length;
      return state.oma_cc_num.slice(numLen - 4);
    },
    getCCExpMonth(state){
      if(state.oma_cc_expiration == null){return null;}
      const regex = new RegExp(/^(\d{2}) \/ (\d{4})$/);
      return state.oma_cc_expiration.match(regex)[1]??null;
    },
    getCCExpYear(state){
      if(state.oma_cc_expiration == null){return null;}
      const regex = new RegExp(/^(\d{2}) \/ (\d{4})$/);
      return state.oma_cc_expiration.match(regex)[2]??null;
    },
    formattedHireDate(state){
      return state.oma_hiredate? format(parseISO(state.oma_hiredate), 'MM/yyyy'):''
    }
  },
  mutations:{
    clear_bu_details(state){
      state.oma_barg_unit_detail = { fy_used:null, has_payroll_deduct:null, is_ibl:null, unit_common_name:null, unit_cst_msg:null, unit_name:null };
      state.oma_barg_unit_id = null;
    },
    attemptedToInitiate(state){
      state.initiate_attempts ++;
    }
  }
});
